var bmConfig = {};
bmConfig.framework = {};
bmConfig.framework.rootFolder = '/';
